import {
  NOTIFICATION_GET_REQUEST,
  NOTIFICATION_GET_REQUEST_FAILED,
  NOTIFICATION_GET_REQUEST_SUCCESS,
  NOTIFICATION_MARK_READED,
  NOTIFICATION_MARK_READED_FAILED,
  NOTIFICATION_MARK_READED_SUCCESS
} from "../constants";

const initialState = {
  data: [],
  isLoading: false,
  error: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_MARK_READED:
    case NOTIFICATION_GET_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: {}
      };
    case NOTIFICATION_GET_REQUEST_SUCCESS:
      return {
        ...state,
        data: [...action.payload],
        isLoading: false,
        error: {}
      };
    case NOTIFICATION_MARK_READED_SUCCESS:
      return {
        ...state,
        data: [
          ...state.data.map(item =>
            item.id === action.payload ? { ...item, isRead: true } : item
          )
        ],
        isLoading: false,
        error: {}
      };
    case NOTIFICATION_MARK_READED_FAILED:
    case NOTIFICATION_GET_REQUEST_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};
